import { SidebarContentComponent } from '../../components/sidebar/sidebar/sidebar-content-component';

export class SidebarChangedEvent {

    constructor(shouldOpenSidebar: boolean, component?: SidebarContentComponent) {
        this._openSidebar = shouldOpenSidebar;
        this._closeSidebar = !shouldOpenSidebar;
        this._component = component;
    }

    private _openSidebar: boolean;

    get openSidebar(): boolean {
        return this._openSidebar;
    }

    private _closeSidebar: boolean;

    get closeSidebar(): boolean {
        return this._closeSidebar;
    }

    private _component: SidebarContentComponent;

    get component(): SidebarContentComponent {
        return this._component;
    }
}
